<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="box-header">
        <span class="box-header__title">Редактировать данные</span>

        <el-popconfirm
          class="confirmBtn"
          @onConfirm="deleteQuestionnaire"
          title="Вы уверены?"
          confirmButtonText="Да"
          cancelButtonText="Нет"
          confirmButtonType="danger"
          cancelButtonType="default"
        >
          <el-button
            slot="reference"
            class="box-header__button"
            :loading="loadDeleteForm"
            size="mini"
            type="danger"
          >Удалить анкету</el-button>
        </el-popconfirm>
      </div>

      <el-form ref="editForm" :rules="editFormRules" :model="loadData" class="edit-form">
        <el-form-item label="Название" prop="title">
          <el-input name="title" autosize placeholder="Введите название анкеты..." v-model="loadData.title"></el-input>
        </el-form-item>
        <el-form-item label="Описание" prop="description">
          <el-input
            name="description"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="Описание анкеты..."
            v-model="loadData.description"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button name="update" type="primary" :loading="loadEditForm" @click="editQuestionnaire()" class="edit-form__btm">Обновить</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="box-header">
        <span class="box-header__title">Список вопросов</span>
        <el-button
          name="add"
          class="box-header__button"
          @click="addQuestion"
          size="mini"
          type="primary"
        >Добавить вопрос</el-button>
      </div>

      <template>
        <el-table :data="loadData.questions" v-if="loadData" class="table" v-loading="loadTable">
          <el-table-column prop="schema.text" label="Вопрос"></el-table-column>
          <el-table-column prop="type" label="Тип вопроса">
            <template slot-scope="scope" >
              <div v-if="$staticData.questionnaire.typeQuestion[scope.row.type]">
                {{ $staticData.questionnaire.typeQuestion[scope.row.type].title }}
              </div>
                <el-badge v-else value="Не поддерживается" class="table-data__badge" type="danger"/>
            </template>
          </el-table-column>
          <el-table-column prop="schema.compendium" label="Связанный справочник"></el-table-column>
          <el-table-column label="Пол">
            <template slot-scope="scope">
                <el-badge v-for="gender in scope.row.gender"
                :key="gender.id" :value="gender.title" class="table-data__badge" type="info"></el-badge>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="140" label="Действие" align="center">
            <template slot-scope="scope">
              <el-tooltip content="Редактировать" placement="top">
                <el-button
                  size="mini"
                  @click="editQuestion(scope.row, scope.$index)"
                  class="table__btn"
                  type="primary"
                  icon="el-icon-edit"
                  circle
                />
              </el-tooltip>
              <el-tooltip content="Удалить" placement="top">
                <el-popconfirm
                  class="confirmBtn"
                  @onConfirm="deleteQuestion(scope.row.id, scope.$index)"
                  title="Вы уверены?"
                  confirmButtonText="Да"
                  confirmButtonType="danger"
                  cancelButtonType="default"
                  cancelButtonText="Нет"
                >
                  <el-button
                    size="mini"
                    icon="el-icon-delete"
                    circle
                    class="table__btn"
                    slot="reference"
                    type="danger"
                  />
                </el-popconfirm>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <div class="error-load" v-if="errorLoadCard">
        <p>Ошибка загрузки</p>
        <el-button type="danger" @click="loadLogic">Загрузить еще раз</el-button>
      </div>
    </el-card>

    <question-add
      :visible="questionAddModal"
      @update="loadLogic"
      :listId="getId"
      @close="questionAddModal = false"
    />

    <question-edit
      :visible="questionEditModal"
      @update="loadLogic"
      :question="selectQuestion"
      :listId="getId"
      @close="questionEditModal = false"
    />

  </div>
</template>

<script>
import QuestionAdd from '@/components/dialog/question/Add.vue'
import QuestionEdit from '@/components/dialog/question/Edit.vue'
export default {
  name: 'Questionnaire.item',
  data () {
    return {
      editForm: {},
      loadData: {},
      loading: false,
      questionAddModal: false,
      questionEditModal: false,
      loadEditForm: false,
      loadDeleteForm: false,
      loadTable: false,
      errorLoadCard: false,
      questionnaire: {
        title: null,
        description: null
      },
      selectQuestion: null,
      error: null,
      editFormRules: {
        title: [
          { required: true, message: 'Укажите название', trigger: 'blur' }
        ],
        description: [
          { required: true, message: 'Укажите описание', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.loading = !!1
    this.loadLogic()
  },
  computed: {
    getId () {
      return this.$route.params.id
    }
  },
  components: { QuestionAdd, QuestionEdit },
  methods: {
    loadLogic () {
      this.$api.questionnaire
        .getQuestionnaire(this.getId)
        .then((response) => {
          this.loadData = response.data
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка загрузки списка',
            message: response.data.message
          })
        })
        .finally(() => {
          this.loading = !!0
        })
    },
    handleEdit (id) {
      this.$router.push({
        name: 'cpanel.questionnaire.item',
        params: {
          id
        }
      })
    },
    deleteQuestion (id, index) {
      this.loadTable = !!1

      this.$api.question
        .delete(id)
        .then(() => {
          this.loadData.questions.splice(index, 1)
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка удаления',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loadTable = !!0
        })
    },
    editQuestion (question) {
      this.selectQuestion = question
      this.questionEditModal = !!1
    },
    addQuestion () {
      this.questionAddModal = !!1
    },
    editQuestionnaire () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loadEditForm = !!1
          this.$api.questionnaire
            .update(this.getId, this.loadData)
            .then((response) => {
              this.loadData = response.data
              this.$notify.success({
                title: 'Успешно',
                message: 'Данные обновлены'
              })
            })
            .catch((response) => {
              this.$notify.error({
                title: 'Ошибка сохранения',
                message: response.response.data.message
              })
            })
            .finally(() => {
              this.loadEditForm = !!0
            })
        }
      })
    },
    deleteQuestionnaire () {
      this.loadDeleteForm = !!1
      this.$api.questionnaire
        .delete(this.getId)
        .then((response) => {
          this.loadData = response.data
          this.$notify.success({
            title: 'Успешно',
            message: 'Анкета удалена'
          })
          this.$router.push({ name: 'cpanel.questionnaire' })
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка авторизации',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loadDeleteForm = !!0
        })
    },
    saveSubmit () {}
  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 960px;
  margin: 10px auto;

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #aaaeba;
    margin: 5px 0 40px 0;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }
}

.table {
  width: 100%;

  &__btn {
    margin: 5px;
  }
  &__badge {
    padding: 0;

    display: inline-block;
  }

}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__title {
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;

    color: #303133;
  }
}

.edit-form {
  &__btm {
    width: 100%;
  }
}
</style>
